import { cn } from "web-design-system";
import { formatVideoDuration } from "creso-core/utils";
import YoutubePlayIcon from "../icons/YoutubePlayIcon";

export function VideoThumbnail({
  title,
  duration,
  src,
  showPlayIcon = true,
  className,
}: {
  title: string;
  duration?: string | number;
  src: string;
  showPlayIcon?: boolean;
  className?: string;
}) {
  const formattedDuration =
    duration != null && duration !== "" ? formatVideoDuration(duration) : null;

  return (
    <div
      className={cn(
        "relative w-full aspect-video overflow-hidden rounded-xl bg-muted",
        className
      )}
    >
      <img src={src} alt={title} className="size-full object-cover" />
      {showPlayIcon && (
        <div className="absolute top-1/2 left-1/2 z-10 -translate-x-1/2 -translate-y-1/2">
          <YoutubePlayIcon className="size-12" />
        </div>
      )}
      {formattedDuration && (
        <span className="absolute bottom-3 right-3 rounded-sm bg-foreground/80 px-1.5 py-0.5 text-xxs font-medium text-background">
          {formattedDuration}
        </span>
      )}
    </div>
  );
}
